import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

@Component({
  selector: 'page-home',
  templateUrl: 'home.html',
  providers: [
  ]
})
export class HomePage {

  constructor(public navCtrl: NavController,
              public navParams: NavParams) {
    
  }
}




// WEBPACK FOOTER //
// ./src/pages/home/home.ts